import React, { useState } from "react";
import { message, Form, Spin, Modal, Row, Col, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import IntlMessages from "../../util/IntlMessages";
import ds from "../../Services/DataServices"
import { getDecryptID } from "../../appRedux/actions";
import { keyBy } from "lodash";

const MarkCompleteModal = (props) => {
  const { visible, setVisible, status, orderid, setIsDataUpdated, isDataUpdated } = props;
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [getModalLoading, setModalLoading] = useState(false);

  async function postFulfillment(body) {
    const req = ds.postFulfillmentService(body);
    await req
      .then((res) => {
        if (res) {
          setModalLoading(false);
          setVisible(false);
          setIsDataUpdated(true); // !isDataUpdated
        } else {
          message.error("Something went wrong...");
        }
      })
      .catch((e) => {
        setModalLoading(false);
      });
  }

  function onClickMark() {
    if (status != "") {
      setModalLoading(true);
      var body = {
        OrderID: orderid,
        Status: 4, // instead of 0 as completed
        Type: parseInt(status),
      };
      postFulfillment(body);
    }
  }

  return (
    <Modal
      title={
        <h2>
          <IntlMessages id="mainsale.fulfil.pophead"
            values={{
              strong: chunks => <strong>{chunks}</strong>,
              title: getDecryptID(orderid),
            }}
          />
        </h2>
      }
      centered
      visible={visible}
      footer={null}
      onCancel={() => setVisible(false)}

    >
      <Spin
        tip={<IntlMessages id="sell.cashlisting.cashloading" />}
        spinning={getModalLoading}
        size="large"
      >
        <Row>
          <Col span={24}>
            <h3>
              <IntlMessages id="mainsale.fulfil.popcontent" />
            </h3>
          </Col>
        </Row>
        <Row style={{ marginTop: 22 }} gutter={12} justify="end">
          <Col>
            <Button
              className="dk-btn-cancel"
              type="primary"
              onClick={() => {
                setVisible(false);
              }}
            >
              <IntlMessages id="mainsale.fulfil.dontmark" />
            </Button>
          </Col>
          <Col>
            <Button
              className="dk-btn-add"
              type="primary"
              onClick={() => onClickMark()}
            >
              <IntlMessages id="mainsale.fulfil.markcomp" />
            </Button>
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
};

export default MarkCompleteModal;
